import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { DependenteEntidade } from '@entidades';

import { LoadingComponent } from '@components';
import { Alert, Box } from '@intech/web-ui';
import { DependenteService } from '@services';
import { Regular } from './Regular';
import { Pensionista } from './Pensionista';
// import { td, th } from './styles';

export const Beneficiarios: React.FC = () => {

  const [AlertText, setAlertText] = useState<string>("");
  const [ListaDependentes, setListaDependentes] = useState<Array<DependenteEntidade>>();

  useEffect(() => {
    (async () => {
      try {

        const ListaDependentes = await DependenteService.Buscar();
        setListaDependentes(ListaDependentes);

      }
      catch (err) {
        const error = err.response ? err.response.data : err;

        setAlertText(error);
      }
    })();
  }, []);

  function renderDependentes() {
    if (AlertText !== "") {
      return <Alert type="danger">
        {AlertText}
      </Alert>;
    }

    if (ListaDependentes !== undefined) {
      if (ListaDependentes.length > 0 && ListaDependentes[0].NUM_SEQ_GR_FAMIL)
        return (
          <Pensionista ListaDependentes={ListaDependentes} />
        );
      return (
        <Regular ListaDependentes={ListaDependentes} />
      );
    }

    return <LoadingComponent />;
  }

  return renderDependentes();
}